import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BudgetStocksInFocus from '../../collection-templates/budget-stocks-in-focus';

const StocksInFocusFullWidget = (props) => {
  const queryClient = new QueryClient;
  const [darkMode, setDarkMode] = useState(false);
  const [lightMode, setLightMode] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');

    if (dm == 1) {
      setDarkMode(true);
      setLightMode(false);
    } else if (disabledm == 1) {
      setDarkMode(false);
      setLightMode(true);
    } else {
      setDarkMode(false);
      setLightMode(false);
    }

    if (darkMode || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#2B2B2B";
    }
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <BudgetStocksInFocus widget={true} count={4} darkMode={darkMode} lightMode={lightMode} {...props}/>
    </QueryClientProvider>
  );
};

export { StocksInFocusFullWidget };